// /ia-plan/:token — view-only client Internal Audit plan (link in the plan email to the client and the auditors).
// No acknowledgement needed.
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { FirmHeader } from '../components/PublicComponents'
import IAPlanDocument from '../components/IAPlanDocument'

export default function IAPlanView() {
  const { token } = useParams()
  const [d, setD] = useState(undefined)
  useEffect(() => { supabase.rpc('get_ia_plan_by_token', { p_token: token }).then(({ data }) => setD(data || null)) }, [token])

  if (d === undefined) return <div style={{ padding: 40, color: '#999' }}>Loading…</div>
  if (!d || !d.plan) return <div style={{ padding: 40 }}>This audit plan link is not valid. Please contact us at (65) 6376 0550.</div>
  // d.status comes from sql/CANCEL_CONTRACT.sql (older databases simply don't send it).
  if (d.status === 'Cancelled') return <div style={{ padding: 40 }}>This internal audit has been cancelled. Please contact us at (65) 6376 0550 if you have any questions.</div>
  return (
    <div style={{ minHeight: '100vh', background: '#f7f6f3', padding: '30px 16px 60px' }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        <FirmHeader accredited={false} />
        <div style={{ background: '#fff', borderRadius: 12, padding: '24px 22px', border: '0.5px solid rgba(0,0,0,0.1)', overflowX: 'auto' }}>
          <IAPlanDocument company={d.company_name} auditDate={d.audit_date}
            auditors={[d.auditor_name, d.auditor2_name]} standards={d.standards} plan={d.plan} />
        </div>
        <div style={{ textAlign: 'center', marginTop: 14 }}><button onClick={() => window.print()} style={{ fontSize: 13 }}>Print</button></div>
      </div>
    </div>
  )
}
